import React from 'react';
import { Icon } from '@nearst/ui';
import { useOrganization } from '@clerk/clerk-react';

import RestrictedPage from '@components/RestrictedPage/RestrictedPage';

export default function NoShops() {
	const { organization: activeOrganization } = useOrganization();
	return (
		<RestrictedPage>
			<Icon>find_in_page</Icon>
			<h1>No locations found{activeOrganization.name ? ` for ${activeOrganization.name}` : ''}</h1>

			<p>Please choose another location using the menu at the top of the page.</p>
		</RestrictedPage>
	);
}
